export const offersIT = {
    shippingTitle: "SPEDIZIONE GRATUITA",
    shippingText1: "Per ordini superiori a ",
    shippingText2: "€ spedizione gratuita!",
    cashTitle: "PAGAMENTO ALLA CONSEGNA",
    cashText: "Pagamento alla consegna gratuito!",
    topSellers: "I più venduti" 
}